<template>
  <!-- <el-col :span="24">
    <h5 class="text-white mt-3 ml-1">Renewable Energy Analytics</h5>
  </el-col> -->

  <el-col :span="24" class="mb-2 p-0 mt-20">
    <div class="row m-0">
      <el-row :gutter="$vuetify.display.width > 1500 ? 20 : 10">
      <!-- Group by tabs -->
      <el-col
        :span="$vuetify.display.width > 1500 ? 7 : 22"
        :class="'x-start order-1 mb-10'"
      >
        <el-tooltip
          effect="light"
          placement="top"
          show-after="500"
          hide-after="300"
        >
          <template #content>
            <span v-if="sessionFilter == 2" :style="{fontSize: '12px', textAlign: 'left'}">Select Group By</span>
          </template>
          <el-radio-group
            v-model="selectedGroupBy"
            text-color="#ffff"
            fill="#234B49"
            :class="$vuetify.display.width < 800 ? 'width-100-p' : ''"
            style="display: flex; gap: 8px; white-space: nowrap;"
          >
            <el-radio-button
              class="start-period all-group-by text-center"
              label="1"
              :style="$vuetify.display.width < 800 ? 'flex: 1;' : 'min-width: 80px;'"
            >
              All
            </el-radio-button>
            <el-radio-button
              class="start-period all-group-by text-center"
              label="2"
              :style="$vuetify.display.width < 800 ? 'flex: 1;' : 'min-width: 100px;'"
            >
              {{
                ($vuetify.display.width >= 1007 &&
                  $vuetify.display.width <= 1155) ||
                ($vuetify.display.width > 750 && $vuetify.display.width <= 785) ||
                ($vuetify.display.width < 530 && sessionFilter == 2)
                  ? "Region"
                  : "By Region"
              }}
            </el-radio-button>
            <el-radio-button
              class="charger-group-by text-center end-period"
              label="4"
              :style="$vuetify.display.width < 800 ? 'flex: 1;' : 'min-width: 100px;'"
            >
              {{
                ($vuetify.display.width >= 1007 &&
                  $vuetify.display.width <= 1155) ||
                ($vuetify.display.width > 750 && $vuetify.display.width <= 785) ||
                ($vuetify.display.width < 530 && sessionFilter == 2)
                  ? "Site"
                  : "By Site"
              }}
            </el-radio-button>
          </el-radio-group>
        </el-tooltip>
      </el-col>

      <!-- search bay -->
      <el-col
            :span="$vuetify.display.width > 1500 ? 16 : 24"
            :class="$vuetify.display.width > 1500 ? 'x-start order-2 mb-10 pr-20' : 'x-start order-3 mb-10'"
          >
            <el-input
              v-if="selectedGroupBy == 1"
              size="large"
              v-model="search"
              :placeholder="searchBytabs == 'customer_name' ? 'Type to search by Customer Name' 
                :searchBytabs == 'site_name' ? 'Type to search by Site Name' 
                :searchBytabs == 'postcode' ? 'Type to search by Postcode' 
                :searchBytabs == 'region' ? 'Type to search by Region' 
                :searchBytabs == 'battery_to_ev' ? 'Type to search by Total Battery to EV' 
                :searchBytabs == 'solar_to_ev' ? 'Type to search by Total Solar to EV' 
                : 'Type to search by customer name, site name, postcode, region ...'"
                :prefix-icon="Search"
                class="mixedSearchBar"
                id="mixedSearchBar-input"
                clearable
                @clear="handleRefresh"
            >
              <template #prepend>

                <!-- search_by select -->
                <el-tooltip
                  effect="light"
                  placement="top"
                  show-after="500"
                  hide-after="300"
                  >
                  <template #content > 
                      <span :style="{fontSize: '12px', textAlign: 'left'}"> {{ "Select Search by" }} </span>
                  </template>

                  <el-select
                    v-model="searchBytabs"
                    placeholder="Select"
                    style="min-width: 117px; height: 40px;"
                    @change="handleSelectSearchBy"
                    class="mixedSearchBar-select"
                  >
                    <template #label>
                      <span>Search by: </span>
                      <span style="font-weight: bold">{{ convertTabToTitleCase(searchBytabs) }}</span>
                    </template>
                    <el-option
                      v-for="(item, index) in search_by_dropdown[1]"
                      :key="index"
                      :label="convertTabToTitleCase(item)"
                      :value="item"
                    />
                  </el-select>
                </el-tooltip>
              </template>
              
              <template #append>
                <!-- <el-button :icon="Search" /> -->
                <el-button
                    @click.stop="handleRefresh"
                    class="newSearchButtonClass"
                  >
                  <svg v-if="$vuetify.display.width > 800" class="width-115 height-40">
                            <use
                              href="@/assets/svg/newSvgIcon.svg#newSearchButtonIcon"
                            ></use>
                          </svg>
                          <svg v-else class="width-59 height-40" >
                            <use
                              href="@/assets/svg/newSvgIcon.svg#newSearchButtonIcon-small"
                            ></use>
                          </svg>
                </el-button>
              </template>
            </el-input>

            <el-input
              v-if="selectedGroupBy != 1"
              size="large"
              v-model="search"
              :placeholder="selectedGroupBy == 3 ? 'Type to search by Charger' : selectedGroupBy == 4 ? 'Type to search by Charging Site' : selectedGroupBy == 5 ? 'Type to search by Description' : selectedGroupBy == 2 ? 'Type to search by Region(State)' : 'Type to search by site name, charger ID, port ...'"
              :prefix-icon="Search"
              class="mixedSearchBar-2"
              id="mixedSearchBar-input-2"
              clearable
              @clear="handleRefresh"
            >
              <template #append>
                <el-button
                @click.stop="handleRefresh"
                class="newSearchButtonClass"
              >
              <svg v-if="$vuetify.display.width > 800" class="width-115 height-40">
                            <use
                              href="@/assets/svg/newSvgIcon.svg#newSearchButtonIcon"
                            ></use>
                          </svg>
                          <svg v-else class="width-59 height-40" >
                            <use
                              href="@/assets/svg/newSvgIcon.svg#newSearchButtonIcon-small"
                            ></use>
                          </svg>
              </el-button>
              </template>
            </el-input>
            
      </el-col>

      <!-- export button -->
      <el-col
            :class="$vuetify.display.width > 1500 ? 'd-flex justify-content-end order-3' : 'justify-content-end order-2'"
            :span="$vuetify.display.width > 1500 ? 1 : 2"
          >
            <el-button
              @click.stop="handleExportFile"
              class="new-download-file-btn new-button-behavior"
            >
                <svg class="width-40 height-40">
                  <use href="@/assets/svg/newSvgIcon.svg#newDownloadFileIcon"></use>
                </svg>
            </el-button>
      </el-col>
      </el-row>
    </div>
  </el-col>

  <!-- table -->
  <el-col :span="24">
    <div
      class="ma-0"
      v-loading="loading"
      :element-loading-spinner="svg"
      element-loading-svg-view-box="-10, -10, 50, 50"
      element-loading-background="rgba(122, 122, 122, 0.8)"
    >
    
    <div class="custom-table-design">
      <!-- Tab All -->
      <el-table
        v-if="selectedGroupBy == '1'"
        :data="sessionDataList"
        :fit="true"
        height="300"
        class="my-2 width-100-p data-table"
        stripe
        scrollbar-always-on: false
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          v-if="
            $store.state.auth.user != null
          "
          :label="'Customer'"
          :prop="'customer_name'"
          :width="$vuetify.display.width <= 1944 ? 158  : ''"
          sortable
        />
        <el-table-column
          :label="'Postcode'"
          :prop="'postcode'"
          :width="$vuetify.display.width <= 1944 ? 180  : ''"
          sortable
        />
        <el-table-column
          :label="'Region'"
          :prop="'region'"
          :width="$vuetify.display.width <= 1944 ? 250  : ''"
          sortable
        >
          <template #default="scope">
            {{
              scope.row.region == null
                ? ""
                : scope.row.region.toUpperCase()
            }}
          </template>
        </el-table-column>
        <el-table-column
          :label="'Site Name'"
          :prop="'site_name'"
          :width="$vuetify.display.width <= 1944 ? 250  : ''"
          sortable
        />
        <el-table-column
          :label="'Time'"
          :prop="'time'"
          :width="$vuetify.display.width <= 1944 ? 250 : ''"
          sortable
        />
        <el-table-column
          :label="'Solar to EV (KWh)'"
          :prop="'solar_to_ev'"
          :width="$vuetify.display.width <= 1944 ? 250 : $vuetify.display.width <= 800 ? 150 : ''"
          sortable
        >
          <template #default="scope">
            {{
              scope.row.solar_to_ev == null
                ? ""
                : Number(scope.row.solar_to_ev).toLocaleString()
            }}
          </template>
        </el-table-column>
        <el-table-column
          :label="'Battery to EV (KWh)'"
          :prop="'battery_to_ev'"
          :width="$vuetify.display.width <= 1944 ? 250 : $vuetify.display.width <= 800 ? 150 : ''"
          sortable
        >
          <template #default="scope">
            {{
              scope.row.battery_to_ev == null
                ? ""
                : Number(scope.row.battery_to_ev).toLocaleString()
            }}
          </template>
        </el-table-column>
      </el-table>
  
    
      <!-- Tab by region or site -->
      <el-table
        v-else
        :data="sessionDataGroupBy"
        :fit="true"
        height="300"
        class="my-2 width-100-p data-table"
        stripe
        scrollbar-always-on: false
      >
      <el-table-column
          v-if="selectedGroupBy == '2'"
          :label="'Region (State)'"
          :prop="'region'"
          :width="$vuetify.display.width <= 1172 ? 180 : ''"
          sortable
        >
          <template #default="scope">
            {{
              scope.row.region == null
                ? ""
                : scope.row.region.toUpperCase()
            }}
          </template>
        </el-table-column>
        <el-table-column
          v-if="selectedGroupBy == '3' || selectedGroupBy == '4'"
          :label="
            selectedGroupBy == '3'
              ? 'Charger'
              : selectedGroupBy == '4'
              ? 'Charging Site'
              : 'Description'
          "
          :prop="
            selectedGroupBy == '3'
              ? 'charger_name'
              : selectedGroupBy == '4'
              ? 'site_name'
              : 'Description'
          "
          :width="$vuetify.display.width <= 1172 ? 180 : ''"
          sortable
        />
        <el-table-column
          :label="'Number of Records'"
          :prop="'count_battery_to_ev'"
          :width="$vuetify.display.width <= 1172 ? 180 : ''"
          sortable
        >
          <template #default="scope">
            {{
              scope.row.count_battery_to_ev == null
                ? ""
                : Number(scope.row.count_battery_to_ev).toLocaleString()
            }}
          </template>
        </el-table-column>
        <el-table-column
          :label="'Total Solar to EV (MWh)'"
          :prop="'divided_sum_solar_to_ev'"
          :width="$vuetify.display.width <= 1172 ? 230 : ''"
          sortable
        >
          <template #default="scope">
            {{
              scope.row.divided_sum_solar_to_ev == null
                ? ""
                : Number(scope.row.divided_sum_solar_to_ev).toLocaleString()
            }}
          </template>
        </el-table-column>
        <el-table-column
          :label="'Total Battery to EV (MWh)'"
          :prop="'divided_sum_battery_to_ev'"
          :width="$vuetify.display.width <= 1172 ? 230 : ''"
          sortable
        >
          <template #default="scope">
            {{
              scope.row.divided_sum_battery_to_ev == null
                ? ""
                : Number(scope.row.divided_sum_battery_to_ev).toLocaleString()
            }}
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="custom-pagination" v-if="$vuetify.display.width >= 700">
        <el-row
          v-if="selectedGroupBy == '1'"
          class="row-bg"
          justify="space-between"
        >
          <el-col
            :span="5"
            class="d-flex justify-content-start align-items-center"
          >
            <el-select
              v-model="perPageCount"
              placeholder="Select"
              size="small"
              style="width: 70px"
            >
              <el-option label="10" :value="'10'" />
              <el-option label="25" :value="'25'" />
              <el-option label="50" :value="'50'" />
              <el-option label="100" :value="'100'" />
              <el-option label="500" :value="'500'" />
              <el-option label="1k" :value="'1000'" />
            </el-select>
          </el-col>
          <el-col
            :span="8"
            class="d-flex align-items-center justify-content-center"
          >
            <el-pagination
              small
              background
              layout="prev, pager, next"
              :total="total_items"
              v-model:page-size="page_size"
              v-model:current-page="current_page"
              @current-change="changePage"
              class="my-4"
            />
          </el-col>
          <el-col :span="5" class="d-flex justify-content-end align-items-center">
            <span class="text-white">
              {{ ((current_page - 1) * perPageCount + 1).toLocaleString() }}-{{
                current_page * perPageCount > total_items
                  ? total_items.toLocaleString()
                  : (current_page * perPageCount).toLocaleString()
              }}
              of {{ total_items.toLocaleString() }}
            </span>
          </el-col>
        </el-row>
      </div>

      <div class="custom-pagination" v-if="$vuetify.display.width < 700">
        <el-row
          v-if="selectedGroupBy == '1'"
          class="row-bg"
          justify="space-between"
        >
        <el-col
            :span="24"
            class="d-flex align-items-center justify-content-center"
          >
            <el-pagination
              small
              background
              layout="prev, pager, next"
              :total="total_items"
              v-model:page-size="page_size"
              v-model:current-page="current_page"
              @current-change="changePage"
              class="my-4"
            />
          </el-col>
          <el-col
            :span="10"
            class="d-flex justify-content-end align-items-center"
          >
            <el-select
              v-model="perPageCount"
              placeholder="Select"
              size="small"
              style="width: 70px"
            >
              <el-option label="10" :value="'10'" />
              <el-option label="25" :value="'25'" />
              <el-option label="50" :value="'50'" />
              <el-option label="100" :value="'100'" />
              <el-option label="500" :value="'500'" />
              <el-option label="1k" :value="'1000'" />
            </el-select>
          </el-col>
          <el-col :span="10" class="d-flex justify-content-start align-items-center">
            <span class="text-white">
              {{ ((current_page - 1) * perPageCount + 1).toLocaleString() }}-{{
                current_page * perPageCount > total_items
                  ? total_items.toLocaleString()
                  : (current_page * perPageCount).toLocaleString()
              }}
              of {{ total_items.toLocaleString() }}
            </span>
          </el-col>
        </el-row>
      </div>
    </div>
  </el-col>
</template>

<script>
import UserService from "@/services/user.service";
import {convertToTitleCase} from "@/pages/dashboard/common/common-tools"

// import XLSX from "xlsx";
// import moment from "moment";
import { exportToExcel } from "@/pages/dashboard/common/exportExcel";
export default {
  props: {
    filterProp: {
      type: Object,
      default: null,
    },
  },
  components: {},
  data() {
    return {
      selectedGroupBy: "1",
      searchBytabs: "customer_name",
      search_by_dropdown: {
        1: ['customer_name', 'site_name', 'postcode', 'region', 'battery_to_ev', 'solar_to_ev'],
      },
      sessionFilter: "2",
      sessionDataList: [],
      sessionDataGroupBy: [],
      pendingSelectionList: [],
      search: "",
      loading: false,
      current_page: 1,
      page_size: 50,
      total_items: 100,
      perPageCount: 50,
      excelDataList: [],
      total: {
        total_count: 0,
        total_usage: 0,
      },
    };
  },
  watch: {
    // watch when search by tabs changes
    searchBytabs: function() {
      this.search = ""; // clear search input when switch search by tabs
    },

    filterProp: {
      handler: function (newValue) {
        console.log(newValue);
        //this.fetchSessionData(this.current_page, this.search);
        this.handleRefresh();
      },
      deep: true,
    },
    selectedGroupBy: function () {
      
      this.fetchSessionGroupBy(this.search);
      
      this.$emit("filterHandle", this.filter);
    },
    sessionFilter: function () {
      this.current_page = 1;
      this.page_size = 50;
      this.perPageCount = 50;
      this.selectedGroupBy = "1";
    },
    current_page: function (newVal) {
      this.current_page = newVal;
      this.fetchSessionGroupBy();
    },
    perPageCount: function (newVal) {
      this.current_page = 1;
      this.page_size = parseInt(newVal);
      this.fetchSessionGroupBy();
    },
  },
  mounted() {
    // this.fetchSessionData(this.current_page, this.search); // new custom filter will be applied to fetch Currnet Period data
  },
  methods: {

    // table tab logic
    /**
     * Session Filter:
     * sessionFilter: 2 - Renewable Energy Analytics
     * 
     * Group by tab All, By Region, By Site:
     * selectedGroupBy: 1 - All, 2 - By Region, 4 - By Site
     *
     */

     convertTabToTitleCase(str){
      return convertToTitleCase(str);
     },
// session search by

  /**
   * /////////////////
   * Renewable Energy Analytics > Group By: By Region, By Site
   * By All
   *  - endpoint: /api/dashboard-session-group-by
   *  - params: start_time, end_time, group_by, command (table_card / chart), state, customer_id (optional), search (optional), search_by (optional)
   * 
   * By Site:
   *  - endpoint: /api/dashboard-session-group-by
   * - params: start_date, end_date, group_by, command (table_card / chart), state, customer_id (optional), search (optional), search_by (optional)
   * 
   * By Region:
   *  - endpoint: /api/dashboard-session-group-by
   * - params: start_date, end_date, group_by, command (table_card / chart), state, customer_id (optional), search (optional), search_by (optional)
   * 
   * 
   */

  //  fetch data for table and card
    async fetchSessionGroupBy() {

      let group_by_dict = {
        "1" : "all",
        "2" : "region",
        "3" : "charger",
        "4" : "site"
      }
      // console.log("filterProp", this.filterProp);

      let filter = {
        start_time: this.filterProp.startDate,
        end_time: this.filterProp.endDate,
        group_by:  group_by_dict[this.selectedGroupBy],
        command: "table_card"
      }

      // if has selected customer_id in filter, add customer id into request body
      if (this.filterProp.customer_id && this.filterProp.customer_id != "") {
        filter.customer_id = this.filterProp.customer_id;
      }
      if (this.filterProp.elec_region) {
        filter.elec_region = this.filterProp.elec_region;
      }
      if (this.filterProp.country) {
        filter.country = this.filterProp.country;
      }
      if(this.selectedGroupBy == "2" && this.search){
        filter.search_by = 'region';
        filter.search = this.search;
      }
      if(this.selectedGroupBy == "4" && this.search){
        filter.search_by = 'site_name';
        filter.search = this.search;
      }
      if(this.selectedGroupBy == "1" && this.search) {
        filter.search_by = this.searchBytabs;
        filter.search = this.search;
        // console.log("search_by", filter.search_by);
        // console.log("search", filter.search);
      }

      // console.log("filter", filter);
      
      this.loading = true;
      await UserService.renewableEnergyAnalytics(filter, this.current_page, this.page_size)
        .then(
          (response) => {

            if (!response.data.data.grouped_data || Object.values(response.data.data.grouped_data).length == 0) {
              this.loading = false;
              this.sessionDataList = [];
              this.sessionDataGroupBy = [];
              this.$emit("sessionDataToParent", {
                "selectedGroupBy": response.data.data.group_by,
                "totalCount": 0,
                "totalUsage": 0,
              });
              console.log("no table and card data in response");
              return;
            }

            let results = response.data.data.grouped_data;

            // let total_records = response.data.data.total_records;
            let group_by_name = response.data.data.group_by;
            let total_count = response.data.data.total_divided_sum_battery;
            let total_usage = response.data.data.total_divided_sum_solar;
            let table_data = this.processTableData(results);

            if (group_by_name && group_by_name == "all") {
              this.total_items = response.data.data.total_records;
            }
    
            this.sessionDataList = table_data;
            this.sessionDataGroupBy = table_data;
            this.$emit("sessionDataToParent", {
                "selectedGroupBy": group_by_name,
                "totalCount": total_count,
                "totalUsage": total_usage,
              });

          },
          (error) => {
            this.loading = false;
            console.log(error.message);
            // if (error.response.status == 401) {
            //     this.$router.push({
            //       path: "/",
            //     });
            //   }

          }
        )
        .catch((error) => {
          this.loading = false;
          console.log(error.message);
          // if (error.response.status == 401) {
          //   this.$router.push({
          //     path: "/",
          //   });
          // }
        })
        .finally(() => (this.loading = false));
    },

    processTableData(results) {
      
      return Object.values(results).map(value => {
        return Object.entries(value).reduce((row, [key, val]) => {
          row[key] = val;
          return row;
        }, {});
      });
    },


    handleRefresh() {
      this.current_page = 1;
      this.fetchSessionGroupBy();
    },

    handleSelectionChange(item) {
      this.pendingSelectionList = item;
    },


    async downloadChargersXlsx(dataList) {
      // console.log("dataList", dataList);
      try {
        // console.log("tableData", dataList);
        const groupBy = this.selectedGroupBy;

        let mainTitle = "Onsite Renewable Energy Analytics";
        let selectedTableTab = groupBy == 1 ? "All" : groupBy == 2 ? "By Region" : groupBy == 4 ? "By Site" : "By Error";

        let skipKeysSessions = [];
        if (selectedTableTab == "All") {
          skipKeysSessions = ["city", "customer_id", "total_battery_to_ev", "total_solar_to_ev"];
        } else if (selectedTableTab == "By Region") {
          skipKeysSessions = ["solar_to_ev", "battery_to_ev"];
        } else if (selectedTableTab == "By Site") {
          skipKeysSessions = ["solar_to_ev", "battery_to_ev"];
        }

        const skipKeys = skipKeysSessions;
        
        const fileName = `${mainTitle}_Group_By_${selectedTableTab}.xlsx`; // File name
        const newWorksheetName = `Group By ${selectedTableTab}`; // Worksheet name
        const title = `${mainTitle} - ${selectedTableTab}`; // Title for the Excel file

        // console.log(fileName, newWorksheetName, title, skipKeys);
        await exportToExcel({
          dataList,
          skipKeys,
          fileName,
          newWorksheetName,
          title,
        });

      } catch (error) {
        console.error("error when download file", error);
      }
    },

    async handleExportFile() {
      if (this.sessionDataList.length > 0) {
        this.downloadChargersXlsx(this.sessionDataList);
      } else {
        console.log("received empty datalist for excel");
        return;
      }
    },
  },
};
</script>
